<template>
    <figure class="the-quote">
        <blockquote class="the-quote__quote">
            <p>"{{ quoteText }}"</p>
        </blockquote>
        <figcaption v-if="captionText" class="the-quote__caption" v-html="captionText" /> <!-- eslint-disable-line vue/no-v-html -->
    </figure>
</template>

<script setup>
defineProps({
    quoteText: {
        type: String,
        required: true,
        default: '',
    },
    captionText: {
        type: String,
        default: null
    },
});
</script>

<style lang="less" src="./TheQuote.less"></style>
